export const closeAutoShipPopUps = () => {
  return (dispatch, getState) => {
    dispatch({ type: 'CLOSE_AUTOSHIP_POPUPS' });
  };
};

export const loadAutoShipCompany = ({ clinicID, userID }) => {
  return (dispatch, getState, { getFirestore }) => {
    const firestore = getFirestore();

    firestore
      .collection('companies')
      .doc(clinicID)
      .get()
      .then((snapShot) => {
        if (!snapShot.isEmpty) {
          let clinic = { id: snapShot.id, data: snapShot.data() };

          firestore
            .collection('tiers')
            .doc(snapShot.data().companyNaturalTier)
            .get()
            .then((natSnapShot) => {
              clinic.naturalTier = natSnapShot.data();
              clinic.naturalTier.id = natSnapShot.id;

              firestore
                .collection('tiers')
                .doc(snapShot.data().companyPureTier)
                .get()
                .then((pureSnapShot) => {
                  clinic.pureTier = pureSnapShot.data();
                  clinic.pureTier.id = pureSnapShot.id;

                  const autoshipField = 'recentSearches.' + clinicID;

                  firestore
                    .collection('users')
                    .doc(userID)
                    .update({
                      [autoshipField]: { searched: new Date(), name: clinic.data.name },
                    })
                    .then(() => {
                      dispatch({ type: 'AUTOSHIP_COMPANY_FOUND', clinic });
                    });
                });
            });
        } else {
          dispatch({ type: 'AUTOSHIP_COMPANY_COULD_NOT_BE_FOUND' });
        }
      })
      .catch((err) => {
        dispatch({ type: 'ERROR_FINDING_AUTOSHIP_COMPANY', err });
      });
  };
};

export const loadAutoShipCompanyfromSearch = ({ clinicID }) => {
  return (dispatch, getState, { getFirestore }) => {
    const firestore = getFirestore();

    firestore
      .collection('companies')
      .doc(clinicID)
      .get()
      .then((snapShot) => {
        if (!snapShot.isEmpty) {
          let clinic = { id: snapShot.id, data: snapShot.data() };

          firestore
            .collection('tiers')
            .doc(snapShot.data().companyNaturalTier)
            .get()
            .then((natSnapShot) => {
              clinic.naturalTier = natSnapShot.data();
              clinic.naturalTier.id = natSnapShot.id;

              firestore
                .collection('tiers')
                .doc(snapShot.data().companyPureTier)
                .get()
                .then((pureSnapShot) => {
                  clinic.pureTier = pureSnapShot.data();
                  clinic.pureTier.id = pureSnapShot.id;

                  dispatch({ type: 'AUTOSHIP_COMPANY_FOUND', clinic });
                });
            });
        } else {
          dispatch({ type: 'AUTOSHIP_COMPANY_COULD_NOT_BE_FOUND' });
        }
      })
      .catch((err) => {
        dispatch({ type: 'ERROR_FINDING_AUTOSHIP_COMPANY', err });
      });
  };
};

export const createNewAutoShip = (clinic, user) => {
  return (dispatch, getState, { getFirestore }) => {
    const firestore = getFirestore();

    firestore
      .collection('autoshipOrders')
      .add({
        clinicID: clinic.id,
        clinicName: clinic.data.name,
        userID: user.id,
        userName: user.fullName,
        orderStarted: new Date(),
        lastEdited: new Date(),
        submitted: false,
      })
      .then((ref) => {
        //console.log('this is my ref', ref);

        //Create an entrie in the company order listing
        const autoshipField = 'autoShipOrders.' + ref.id;
        firestore
          .collection('companies')
          .doc(clinic.id)
          .update({
            [autoshipField]: { created: new Date(), clinic: clinic.data.name },
          })
          .then(() => {
            //Then add it to the users files
            firestore
              .collection('users')
              .doc(user.id)
              .update({
                [autoshipField]: { created: new Date(), clinic: clinic.data.name },
              })
              .then(() => {
                let resp = { id: ref.id };
                dispatch({ type: 'AUTOSHIP_ORDER_CREATED', resp });
              });
          });
      })
      .catch((err) => {
        dispatch({ type: 'ERROR_CREATING_AUTOSHIP_ORDER', err });
      });
  };
};

export const elevateAutoShipOrder = () => {
  return (dispatch, getState) => {
    dispatch({ type: 'ELVATE_AUTOSHIP_ORDER' });
  };
};

//This function will build the page and setup  the reducer for the base information
//Grab months
//Grab the settings from the autoship settings in the database
//Send that data to the reducer
export const buildAutoShipData = () => {
  return (dispatch, getState, { getFirestore }) => {
    const firestore = getFirestore();

    firestore
      .collection('lists')
      .doc('months')
      .get()
      .then((snapShot) => {
        if (!snapShot.isEmpty) {
          const months = snapShot.data().monthOrder;

          firestore
            .collection('autoship')
            .doc('settings')
            .get()
            .then((setSnapShot) => {
              const settings = setSnapShot.data();

              firestore
                .collection('items')
                .get()
                .then((itemSnapShots) => {
                  if (!itemSnapShots.isEmpty) {
                    const items = [];

                    itemSnapShots.forEach((item) => {
                      return items.push({ id: item.id, data: item.data() });
                    });

                    //Need to get the tiers as well
                    firestore
                      .collection('tiers')
                      .get()
                      .then((tierSnapShots) => {
                        const tiers = [];

                        tierSnapShots.forEach((tier) => {
                          return tiers.push({ id: tier.id, data: tier.data() });
                        });

                        let resp = { months: months, settings: settings, items: items, tiers: tiers };
                        dispatch({ type: 'AUTOSHIP_SETTINGS_LOADED', resp });
                      });
                  } else {
                    dispatch({ type: 'AUTOSHIP_NO_ITEMS' });
                  }
                });
            });
        } else {
          dispatch({ type: 'ERROR_NO_MONTHS_FOUND' });
        }
      })
      .catch((err) => {
        dispatch({ type: 'ERROR_GETTING_MONTHS', err });
      });
  };
};

//This function will build just the basic data
//Items
//Send that data to the reducer
export const buildSmallAutoShipData = () => {
  return (dispatch, getState, { getFirestore }) => {
    const firestore = getFirestore();

    firestore
      .collection('items')
      .get()
      .then((itemSnapShots) => {
        if (!itemSnapShots.isEmpty) {
          const items = [];

          itemSnapShots.forEach((item) => {
            return items.push({ id: item.id, data: item.data() });
          });

          //Need to get the tiers as well
          firestore
            .collection('tiers')
            .get()
            .then((tierSnapShots) => {
              const tiers = [];

              tierSnapShots.forEach((tier) => {
                return tiers.push({ id: tier.id, data: tier.data() });
              });

              let resp = { items: items, tiers: tiers };
              dispatch({ type: 'AUTOSHIP_SETTINGS_LIGHT_LOADED', resp });
            });
        } else {
          dispatch({ type: 'AUTOSHIP_NO_ITEMS' });
        }
      });
  };
};

export const selectMonthToEdit = (month) => {
  return (dispatch, getState) => {
    dispatch({ type: 'SELECTING_MONTHING_TO_EDIT', month });
  };
};

export const selectBrandToEdit = (brand) => {
  return (dispatch, getState) => {
    dispatch({ type: 'SELECTING_BRAND_TO_EDIT', brand });
  };
};

export const addItemtoOrder = ({ item, month, brand, row }) => {
  return (dispatch, getState) => {
    const resp = { item: item, month: month, brand: brand, row: row };
    dispatch({ type: 'ADD_ITEM_TO_ORDER', resp });
  };
};

export const adjustItemQuantitytoOrder = ({ adjust, month, brand, row }) => {
  return (dispatch, getState) => {
    const resp = { adjust: adjust, month: month, brand: brand, row: row };
    dispatch({ type: 'ADD_QUANTITY_TO_ITEM_ORDER', resp });
  };
};

export const loadAutoShipOrder = ({ orderID, load }) => {
  return (dispatch, getState, { getFirestore }) => {
    const firestore = getFirestore();
    //console.log('this is my orderID', orderID);
    firestore
      .collection('autoshipOrders')
      .doc(orderID)
      .get()
      .then((snapShot) => {
        if (!snapShot.isEmpty) {
          let resp = { id: snapShot.id, data: snapShot.data() };
          if (load === 'order') {
            //The clinic is already loaded so we don't need to do another run for data
            dispatch({ type: 'AUTOSHIP_ORDER_FOUND', resp });
          } else {
            //We will look for the clinic
            firestore
              .collection('companies')
              .doc(resp.data.clinicID)
              .get()
              .then((snapShot) => {
                if (!snapShot.isEmpty) {
                  let clinic = { id: snapShot.id, data: snapShot.data() };

                  firestore
                    .collection('tiers')
                    .doc(snapShot.data().companyNaturalTier)
                    .get()
                    .then((natSnapShot) => {
                      clinic.naturalTier = natSnapShot.data();
                      clinic.naturalTier.id = natSnapShot.id;

                      firestore
                        .collection('tiers')
                        .doc(snapShot.data().companyPureTier)
                        .get()
                        .then((pureSnapShot) => {
                          clinic.pureTier = pureSnapShot.data();
                          clinic.pureTier.id = pureSnapShot.id;

                          resp.clinic = clinic;

                          dispatch({ type: 'AUTOSHIP_ORDER_AND_CLINIC_FOUND', resp });
                        });
                    });
                } else {
                  dispatch({ type: 'AUTOSHIP_COMPANY_COULD_NOT_BE_FOUND' });
                }
              })
              .catch((err) => {
                dispatch({ type: 'ERROR_FINDING_AUTOSHIP_COMPANY', err });
              });
          }
        } else {
          dispatch({ type: 'NO_AUTOSHIP_ORDER_FOUND' });
        }
      })
      .catch((err) => {
        dispatch({ type: 'ERROR_SEARCHING_FOR_AUTOSHIP_ORDER', err });
      });
  };
};

export const startSavingProgress = () => {
  return (dispatch, getState) => {
    dispatch({ type: 'STARTING_SAVING_ORDER' });
  };
};

export const saveAutoShipOrder = ({ clinic, user, order, name }) => {
  return (dispatch, getState, { getFirestore }) => {
    const firestore = getFirestore();
    //console.log('this is my order', order);
    //console.log('this is my name ---->< ', name);
    firestore
      .collection('autoshipOrders')
      .doc(order.id)
      .update({
        order: order,
        lastEdited: new Date(),
        name: name,
      })
      .then((ref) => {
        //console.log('this is my ref', ref);

        //Create an entrie in the company order listing
        const autoshipField = 'autoShipOrders.' + order.id;
        firestore
          .collection('companies')
          .doc(clinic.id)
          .update({
            [autoshipField]: { created: new Date(), clinic: clinic.data.name, name: name, elvated: order.programElevate },
          })
          .then(() => {
            //Then add it to the users files
            firestore
              .collection('users')
              .doc(user)
              .update({
                [autoshipField]: { created: new Date(), clinic: clinic.data.name, name: name, elvated: order.programElevate },
              })
              .then(() => {
                dispatch({ type: 'AUTOSHIP_ORDER_WAS_SAVED' });
              });
          });
      })
      .catch((err) => {
        dispatch({ type: 'ERROR_SAVING_AUTOSHIP_ORDER', err });
      });
  };
};

export const copyMonthOrder = (month) => {
  return (dispatch, getState) => {
    dispatch({ type: 'COPY_MONTH_ORDER', month });
  };
};

export const copyShippingIDOrder = (shippingID) => {
  return (dispatch, getState) => {
    dispatch({ type: 'COPY_SHIPPING_ID_ORDER', shippingID });
  };
};

export const exitAutoShipApp = () => {
  return (dispatch, getState) => {
    dispatch({ type: 'EXIT_AUTOSHIP_ORDER' });
  };
};

export const clearAutoShipApp = () => {
  return (dispatch, getState) => {
    dispatch({ type: 'CLEAN_AUTOSHIP_ORDER' });
  };
};

export const submitAutoShipOrder = (orderID, userID, form) => {
  return (dispatch, getState, { getFirestore }) => {
    const firestore = getFirestore();
    console.log('this is my form', form);
    firestore
      .collection('autoshipOrders')
      .doc(orderID)
      .update({
        submitted: true,
        submittedDate: new Date(),
        submittedUser: userID,
        form: form,
      })
      .then((ref) => {
        dispatch({ type: 'SUBMIT_AUTOSHIP_ORDER' });
      })
      .catch((err) => {
        dispatch({ type: 'ERROR_SUBMITTING_AUTOSHIP_ORDER' });
      });
  };
};

export const favoriteAutoShipClinic = ({ clinic, user }) => {
  return (dispatch, getState, { getFirestore }) => {
    const firestore = getFirestore();

    //Create an entrie in the company order listing
    const autoshipField = 'favClinics.' + clinic.id;

    firestore
      .collection('users')
      .doc(user)
      .update({
        [autoshipField]: { created: new Date(), clinic: clinic.name, clinicID: clinic.id },
      })
      .then(() => {
        dispatch({ type: 'AUTOSHIP_COMPANY_WAS_FAV' });
      })
      .catch((err) => {
        dispatch({ type: 'ERROR_FAV_AUTOSHIP_CLINIC', err });
      });
  };
};

export const unFavoriteAutoShipClinic = ({ clinic, user }) => {
  return (dispatch, getState, { getFirestore }) => {
    const firestore = getFirestore();

    //Create an entrie in the company order listing
    const autoshipField = 'favClinics.' + clinic;

    firestore
      .collection('users')
      .doc(user)
      .update({
        [autoshipField]: firestore.FieldValue.delete(),
      })
      .then(() => {
        dispatch({ type: 'AUTOSHIP_COMPANY_WAS_REMOVED_FROM_FAV' });
      })
      .catch((err) => {
        dispatch({ type: 'ERROR_REMOVING_FAV_AUTOSHIP_CLINIC', err });
      });
  };
};

export const addAnotherItemToMonth = ({ brand, month }) => {
  return (dispatch, getState) => {
    //Create an entrie in the company order listing
    let resp = { brand: brand, month: month };
    dispatch({ type: 'ADD_ANOTHER_ITEM_TO_MONTH', resp });
  };
};

export const copyAutoShipOrder = ({ user, order }) => {
  return async (dispatch, getState, { getFirestore }) => {
    const firestore = getFirestore();
    let newAutoshipOrder = {};
    let items = [];

    console.log('This is the order that I am copy ----->', order);

    //We are going to copy the order here
    let autoShipCompany = await firestore.collection('companies').doc(order.clinicID).get();

    let naturalTier = await firestore.collection('tiers').doc(autoShipCompany.data().companyNaturalTier).get();
    let pureTier = await firestore.collection('tiers').doc(autoShipCompany.data().companyPureTier).get();

    //We need to get the current settings for the month and the months that we will need
    let settings = await firestore.collection('autoship').doc('settings').get();

    //This will get us the starting month and the next set of months.. If no months then use January.
    let startMonth = settings.exists ? settings.data().startMonth : 0;

    let monthList = await firestore.collection('lists').doc('months').get();
    let months = [];
    let monthOrder = [];
    let monthTotals = [];
    //We want to get the price tier from the company
    //let pricingTier = order.order.pricingTier;
    let pricingTier = autoShipCompany.exists
      ? pureTier.data().tierName !== naturalTier.data().tierName
        ? pureTier.data().tierName !== 'Silver'
          ? pureTier.data().tierName !== 'Bronze'
            ? autoShipCompany.data().companyPureTier
            : '3IaLvKVToLsbcC8neru7' //Silver ID
          : 'hfgJtLRuei3Ac42Gu1tj' //Gold ID
        : naturalTier.data().tierName !== 'Silver' //I will need to grab gold if silver
        ? naturalTier.data().tierName !== 'Bronze'
          ? autoShipCompany.data().companyNaturalTier
          : '3IaLvKVToLsbcC8neru7' //Silver ID
        : 'hfgJtLRuei3Ac42Gu1tj' //Gold ID
      : order.order.pricingTier;

    if (monthList.exists) {
      await Promise.all(
        monthList.data().monthOrder.map((month) => {
          return months.push(month);
        })
      );
    }

    //console.log('this is my company data ---> ', autoShipCompany.data());

    let lastMonth = startMonth + (autoShipCompany.data().eliteProgram ? 11 : 5);

    //console.log('what is my last month === ', lastMonth);
    if (lastMonth < 12) {
      //lets do the standard here
      for (let i = startMonth; i <= lastMonth; i++) {
        monthOrder.push(months[i]);
        monthTotals.push({ month: months[i], total: 0 });
      }
    } else {
      const extraMonths = lastMonth - 12;
      //Go through the first set of months
      for (let i = startMonth; i < 12; i++) {
        monthOrder.push(months[i]);
        monthTotals.push({ month: months[i], total: 0 });
      }
      //Then we start off at the year and go through it again
      for (let i = 0; i <= extraMonths; i++) {
        monthOrder.push(months[i]);
        monthTotals.push({ month: months[i], total: 0 });
      }
    }

    //First thing we will need to do is get all of the latest items.
    let latestItems = await firestore.collection('items').get();

    if (!latestItems.empty) {
      await Promise.all(
        latestItems.docs.map((item) => {
          return items.push({ id: item.id, data: { ...item.data() } });
        })
      );
    }

    //////////////////////////////////////////
    // Now we need to go through the item data
    //////////////////////////////////////////

    //Set all of the default values
    const cbItems = [];
    const tItems = [];
    const fItems = [];
    const bItems = [];
    //const cbItemsSorted = [];

    const cbMonths = [];
    const tMonths = [];
    const fMonths = [];
    const bMonths = [];
    const cbItemsMonth = { months: [], bonus: [] };
    const tItemsMonth = { months: [], bonus: [] };
    const fItemsMonth = { months: [], bonus: [] };
    const bItemsMonth = { months: [] };

    //WE are going to sort the brands into thier own item lists.
    await Promise.all(
      items.map((item) => {
        if (item.data.brand === 'Clear + Brilliant') {
          cbItems.push(item);
        }

        if (item.data.brand === 'Fraxel') {
          fItems.push(item);
        }

        if (item.data.brand === 'Thermage') {
          tItems.push(item);
        }
        bItems.push(item);
        return true;
      })
    );

    //Lets sort the items so that they are in order
    const cbItemsSorted = cbItems.sort((a, b) => a.data.listOrder - b.data.listOrder);
    const tItemsSorted = tItems.sort((a, b) => a.data.listOrder - b.data.listOrder);
    const fItemsSorted = fItems.sort((a, b) => a.data.listOrder - b.data.listOrder);

    //console.log('this is my order we are going to copy from ', order);
    //console.log('these are my new items --> ', items);

    //Then we will need to get order
    newAutoshipOrder.clinicID = order.clinicID;
    newAutoshipOrder.clinicName = order.clinicName;
    newAutoshipOrder.lastEdited = new Date();
    newAutoshipOrder.name = order.name;
    newAutoshipOrder.orderStarted = new Date();
    newAutoshipOrder.userID = user.id;
    newAutoshipOrder.userName = user.fullName;

    let newPriceTier = autoShipCompany.exists
      ? pureTier.data().tierName !== naturalTier.data().tierName
        ? pureTier.data().tierName !== 'Silver'
          ? pureTier.data().tierName !== 'Bronze'
            ? autoShipCompany.data().companyPureTier
            : '3IaLvKVToLsbcC8neru7' //Silver ID
          : 'hfgJtLRuei3Ac42Gu1tj' //Gold ID
        : naturalTier.data().tierName !== 'Silver' //I will need to grab gold if silver
        ? naturalTier.data().tierName !== 'Bronze'
          ? autoShipCompany.data().companyNaturalTier
          : '3IaLvKVToLsbcC8neru7' //Silver ID
        : 'hfgJtLRuei3Ac42Gu1tj' //Gold ID
      : order.order.pricingTier;

    //Then we will cycle through the order and update it with the actual data
    newAutoshipOrder.order = {
      clinicName: order.clinicName,
      pricingTier: newPriceTier,
      programElevate: order.order.programElevate,
      monthTotals: {},
      months: monthOrder,
      order: {},
    };

    await Promise.all(
      //Now we will create all of your item stuff
      monthOrder.map((m, mi) => {
        cbMonths.push({ ...m, brand: 'cbmonths' });
        tMonths.push({ ...m, brand: 'tmonths' });
        fMonths.push({ ...m, brand: 'fmonths' });
        bMonths.push({ ...m, brand: 'bmonths' });

        //This will create the array that we will use to store data in

        //Create the base for the items
        cbItemsMonth.months.push({ month: m, amount: 2, items: [] });
        tItemsMonth.months.push({ month: m, amount: 3, items: [] });
        fItemsMonth.months.push({ month: m, amount: 3, items: [] });
        bItemsMonth.months.push({ month: m, amount: 3, items: [] });

        tItemsSorted.map((i) => {
          bItemsMonth.months[mi].items.push({ ...i });
          return tItemsMonth.months[mi].items.push({ ...i });
        });

        fItemsSorted.map((i) => {
          bItemsMonth.months[mi].items.push({ ...i });
          return fItemsMonth.months[mi].items.push({ ...i });
        });

        cbItemsSorted.map((i) => {
          //Just add the items to that month
          bItemsMonth.months[mi].items.push({ ...i });
          return cbItemsMonth.months[mi].items.push({ ...i });
        });

        return null;
      })
    );

    cbItemsMonth.bonus.push({ month: 'bonusTips', amount: 2, items: [] });
    tItemsMonth.bonus.push({ month: 'bonusTips', amount: 3, items: [] });
    fItemsMonth.bonus.push({ month: 'bonusTips', amount: 3, items: [] });

    cbItemsSorted.map((i) => {
      //Just add the items to that month
      return cbItemsMonth.bonus[0].items.push({ ...i });
    });

    tItemsSorted.map((i) => {
      return tItemsMonth.bonus[0].items.push({ ...i });
    });

    fItemsSorted.map((i) => {
      return fItemsMonth.bonus[0].items.push({ ...i });
    });

    newAutoshipOrder.order.cbMonthItems = cbItemsMonth;
    newAutoshipOrder.order.tMonthItems = tItemsMonth;
    newAutoshipOrder.order.fMonthItems = fItemsMonth;
    newAutoshipOrder.order.bItemsMonth = bItemsMonth;

    let totalOrder = 0;

    /////////////////////////////////////////////////
    /////////////////////////////////////////////////
    //MULTIPLE IDS --- We have to check if the we have muplitple ids
    /////////////////////////////////////////////////
    /////////////////////////////////////////////////
    if (order.form.multipleIDs) {
      await Promise.all(
        order.form.shipToId.map(async (sID) => {
          //console.log('this is my ship to ID', sID);
          //Lets go through the order
          newAutoshipOrder.order.order[sID] = {};
          newAutoshipOrder.order.order[sID].months = {};
          newAutoshipOrder.order.order[sID].bonus = { 'Clear + Brilliant': [], Thermage: [], Fraxel: [], itemCount: {} };
          //console.log('this is my ship to ID', sID);
          newAutoshipOrder.order.monthTotals[sID] = {};

          await Promise.all(
            Object.keys(order.order.order[sID].months).map(async (month, i) => {
              let monthTotal = 0; // eslint-disable-line no-unused-vars
              //console.log('this is my i value ---> ', i);
              //console.log('this is my month order then --->', monthOrder[i]);
              newAutoshipOrder.order.order[sID].months[i] = {};

              newAutoshipOrder.order.order[sID].months[i].abbreviation = monthOrder[i].abbreviation;
              newAutoshipOrder.order.order[sID].months[i].name = monthOrder[i].name;
              newAutoshipOrder.order.order[sID].months[i].order = monthOrder[i].order;

              newAutoshipOrder.order.order[sID].months[i].itemCount = order.order.order[sID].months[month].itemCount;

              //Now we need to get the update prices for the items
              newAutoshipOrder.order.order[sID].months[i]['Clear + Brilliant'] = [];
              newAutoshipOrder.order.order[sID].months[i]['Fraxel'] = [];
              newAutoshipOrder.order.order[sID].months[i]['Thermage'] = [];

              newAutoshipOrder.order.order[sID].months[i].total = {};

              newAutoshipOrder.order.monthTotals[sID][i] = { total: 0, ...monthOrder[i] };

              ////////////////////////////////////////////
              //Go through Clear + Brilliant
              ////////////////////////////////////////////
              if (order.order.order[sID].months[i]['Clear + Brilliant'].length > 0) {
                //console.log('am I getting called?');
                let cbTotal = 0;
                await Promise.all(
                  order.order.order[sID].months[i]['Clear + Brilliant'].map((cbItem) => {
                    //console.log('this is my item we need to get the updated price for --> ', cbItem);
                    let updatedItem = items.filter((item) => item.data.sku === cbItem.item);
                    //console.log('Did I find the new Item', updatedItem);
                    if (updatedItem.length > 0) {
                      //console.log('WE have found an item ---> ', updatedItem[0]);
                      let newItem = updatedItem[0];

                      //console.log('this is my cbItem Quantiy and pricing tier', cbItem.quantiy, newItem.data[pricingTier]);
                      newAutoshipOrder.order.order[sID].months[i]['Clear + Brilliant'].push({
                        data: newItem.data,
                        item: cbItem.item,
                        quantiy: cbItem.quantiy,
                        price: cbItem.quantiy * newItem.data[pricingTier],
                      });

                      cbTotal += cbItem.quantiy * newItem.data[pricingTier];
                    }

                    return true;
                  })
                );
                if (cbTotal !== 0) {
                  newAutoshipOrder.order.order[sID].months[i].total['Clear + Brilliant'] = cbTotal;
                  monthTotal += cbTotal;
                  totalOrder += cbTotal;
                  newAutoshipOrder.order.monthTotals[sID][i].total += cbTotal;
                }
              }

              ////////////////////////////////////////////
              //Go through Thermage
              ////////////////////////////////////////////
              if (order.order.order[sID].months[i]['Thermage'].length > 0) {
                let thermageTotal = 0;
                await Promise.all(
                  order.order.order[sID].months[i]['Thermage'].map((thermageItem) => {
                    //console.log('this is my item we need to get the updated price for --> ', cbItem);
                    let updatedItem = items.filter((item) => item.data.sku === thermageItem.item);
                    if (updatedItem.length > 0) {
                      //console.log('WE have found an item ---> ', updatedItem[0]);
                      let newItem = updatedItem[0];
                      newAutoshipOrder.order.order[sID].months[i]['Thermage'].push({
                        data: newItem.data,
                        item: thermageItem.item,
                        quantiy: thermageItem.quantiy,
                        price: thermageItem.quantiy * newItem.data[pricingTier],
                      });

                      thermageTotal += thermageItem.quantiy * newItem.data[pricingTier];
                    }
                    return true;
                  })
                );
                if (thermageTotal !== 0) {
                  newAutoshipOrder.order.order[sID].months[i].total['Thermage'] = thermageTotal;
                  monthTotal += thermageTotal;
                  totalOrder += thermageTotal;
                  newAutoshipOrder.order.monthTotals[sID][i].total += thermageTotal;
                }
              }

              ////////////////////////////////////////////
              //Go through Frraxel
              ////////////////////////////////////////////
              if (order.order.order[sID].months[i]['Fraxel'].length > 0) {
                let fraxelTotal = 0;
                await Promise.all(
                  order.order.order[sID].months[i]['Fraxel'].map((fraxelItem) => {
                    //console.log('this is my item we need to get the updated price for --> ', cbItem);
                    let updatedItem = items.filter((item) => item.data.sku === fraxelItem.item);
                    if (updatedItem.length > 0) {
                      //console.log('WE have found an item ---> ', updatedItem[0]);
                      let newItem = updatedItem[0];
                      newAutoshipOrder.order.order[sID].months[i]['Fraxel'].push({
                        data: newItem.data,
                        item: fraxelItem.item,
                        quantiy: fraxelItem.quantiy,
                        price: fraxelItem.quantiy * newItem.data[pricingTier],
                      });

                      fraxelTotal += fraxelItem.quantiy * newItem.data[pricingTier];
                    }
                    return true;
                  })
                );
                if (fraxelTotal !== 0) {
                  newAutoshipOrder.order.order[sID].months[i].total['Fraxel'] = fraxelTotal;
                  monthTotal += fraxelTotal;
                  totalOrder += fraxelTotal;
                  newAutoshipOrder.order.monthTotals[sID][i].total += fraxelTotal;
                }
              }
            })
          );

          ///////////////////////////////////////////////////////////////////
          //Now we have to go through and add in the Bonus Tips.
          ///////////////////////////////////////////////////////////////////

          //CB Bonus Tips
          if (order.order.order[sID].bonus['Clear + Brilliant'].length > 0) {
            let cbBonusItemCount = 0;
            await Promise.all(
              order.order.order[sID].bonus['Clear + Brilliant'].map((cbBonusItem) => {
                let updatedItem = items.filter((item) => item.data.sku === cbBonusItem.item);
                //console.log('this my bonus new item ---> ', updatedItem);

                if (updatedItem.length > 0) {
                  //console.log('WE have found an item ---> ', updatedItem[0]);
                  let newItem = updatedItem[0];
                  //console.log('this is my new BONUS data item --> ', newItem);

                  newAutoshipOrder.order.order[sID].bonus['Clear + Brilliant'].push({
                    data: newItem.data,
                    item: cbBonusItem.item,
                    quantiy: cbBonusItem.quantiy,
                  });

                  cbBonusItemCount += cbBonusItem.quantiy;
                }
                return true;
              })
            );

            newAutoshipOrder.order.order[sID].bonus.itemCount['Clear + Brilliant'] = cbBonusItemCount;
          }

          //Thermage Bonus Tips

          if (order.order.order[sID].bonus['Thermage'].length > 0) {
            let thermageBonusItemCount = 0;
            await Promise.all(
              order.order.order[sID].bonus['Thermage'].map((thermageBonusItem) => {
                let updatedItem = items.filter((item) => item.data.sku === thermageBonusItem.item);
                if (updatedItem.length > 0) {
                  //console.log('WE have found an item ---> ', updatedItem[0]);
                  let newItem = updatedItem[0];
                  newAutoshipOrder.order.order[sID].bonus['Thermage'].push({
                    data: newItem.data,
                    item: thermageBonusItem.item,
                    quantiy: thermageBonusItem.quantiy,
                  });

                  thermageBonusItemCount += thermageBonusItemCount.quantiy;
                }
                return true;
              })
            );

            newAutoshipOrder.order.order[sID].bonus.itemCount['Thermage'] = thermageBonusItemCount;
          }

          //Fraxel Bonus Tips

          if (order.order.order[sID].bonus['Fraxel'].length > 0) {
            let fraxelBonusItemCount = 0;
            await Promise.all(
              order.order.order[sID].bonus['Fraxel'].map((fraxelBonusItem) => {
                let updatedItem = items.filter((item) => item.data.sku === fraxelBonusItem.item);
                if (updatedItem.length > 0) {
                  //console.log('WE have found an item ---> ', updatedItem[0]);
                  let newItem = updatedItem[0];
                  newAutoshipOrder.order.order[sID].bonus['Thermage'].push({
                    data: newItem.data,
                    item: fraxelBonusItem.item,
                    quantiy: fraxelBonusItem.quantiy,
                  });

                  fraxelBonusItemCount += fraxelBonusItemCount.quantiy;
                }
                return true;
              })
            );

            newAutoshipOrder.order.order[sID].bonus.itemCount['Fraxel'] = fraxelBonusItemCount;
          }
        })
      );
    } else {
      /////////////////////////////////////////////////
      /////////////////////////////////////////////////
      // SINGLE ID - We don't have multiple Ids so we can continue
      /////////////////////////////////////////////////
      /////////////////////////////////////////////////

      //console.log('this is my ship to ID', sID);
      //Lets go through the order
      newAutoshipOrder.order.order = {};
      newAutoshipOrder.order.order.months = [];
      newAutoshipOrder.order.order.bonus = { 'Clear + Brilliant': [], Thermage: [], Fraxel: [], itemCount: {} };
      //console.log('this is my ship to ID', sID);
      newAutoshipOrder.order.monthTotals = {};

      await Promise.all(
        Object.keys(order.order.order.months).map(async (month, i) => {
          let monthTotal = 0; // eslint-disable-line no-unused-vars
          //console.log('this is my i value ---> ', i);
          //console.log('this is my month order then --->', monthOrder[i]);
          let monthData = {
            abbreviation: monthOrder[i].abbreviation,
            name: monthOrder[i].name,
            order: monthOrder[i].order,
            itemCount: order.order.order.months[month].itemCount,
            'Clear + Brilliant': [],
            Fraxel: [],
            Thermage: [],
            total: {},
          };
          newAutoshipOrder.order.order.months.push(monthData);

          newAutoshipOrder.order.monthTotals[i] = { total: 0, ...monthOrder[i] };

          ////////////////////////////////////////////
          //Go through Clear + Brilliant
          ////////////////////////////////////////////
          if (order.order.order.months[i]['Clear + Brilliant'].length > 0) {
            //console.log('am I getting called?');
            let cbTotal = 0;
            await Promise.all(
              order.order.order.months[i]['Clear + Brilliant'].map((cbItem) => {
                //console.log('this is my item we need to get the updated price for --> ', cbItem);
                let updatedItem = items.filter((item) => item.data.sku === cbItem.item);
                //console.log('Did I find the new Item', updatedItem);
                if (updatedItem.length > 0) {
                  //console.log('WE have found an item ---> ', updatedItem[0]);
                  let newItem = updatedItem[0];

                  //console.log('this is my cbItem Quantiy and pricing tier', cbItem.quantiy, newItem.data[pricingTier]);
                  newAutoshipOrder.order.order.months[i]['Clear + Brilliant'].push({
                    data: newItem.data,
                    item: cbItem.item,
                    quantiy: cbItem.quantiy,
                    price: cbItem.quantiy * newItem.data[pricingTier],
                  });

                  cbTotal += cbItem.quantiy * newItem.data[pricingTier];
                }

                return true;
              })
            );
            if (cbTotal !== 0) {
              newAutoshipOrder.order.order.months[i].total['Clear + Brilliant'] = cbTotal;
              monthTotal += cbTotal;
              totalOrder += cbTotal;
              newAutoshipOrder.order.monthTotals[i].total += cbTotal;
            }
          }

          ////////////////////////////////////////////
          //Go through Thermage
          ////////////////////////////////////////////
          if (order.order.order.months[i]['Thermage'].length > 0) {
            let thermageTotal = 0;
            await Promise.all(
              order.order.order.months[i]['Thermage'].map((thermageItem) => {
                //console.log('this is my item we need to get the updated price for --> ', cbItem);
                let updatedItem = items.filter((item) => item.data.sku === thermageItem.item);
                if (updatedItem.length > 0) {
                  //console.log('WE have found an item ---> ', updatedItem[0]);
                  let newItem = updatedItem[0];
                  newAutoshipOrder.order.order.months[i]['Thermage'].push({
                    data: newItem.data,
                    item: thermageItem.item,
                    quantiy: thermageItem.quantiy,
                    price: thermageItem.quantiy * newItem.data[pricingTier],
                  });

                  thermageTotal += thermageItem.quantiy * newItem.data[pricingTier];
                }
                return true;
              })
            );
            if (thermageTotal !== 0) {
              newAutoshipOrder.order.order.months[i].total['Thermage'] = thermageTotal;
              monthTotal += thermageTotal;
              totalOrder += thermageTotal;
              newAutoshipOrder.order.monthTotals[i].total += thermageTotal;
            }
          }

          ////////////////////////////////////////////
          //Go through Frraxel
          ////////////////////////////////////////////
          if (order.order.order.months[i]['Fraxel'].length > 0) {
            let fraxelTotal = 0;
            await Promise.all(
              order.order.order.months[i]['Fraxel'].map((fraxelItem) => {
                //console.log('this is my item we need to get the updated price for --> ', cbItem);
                let updatedItem = items.filter((item) => item.data.sku === fraxelItem.item);
                if (updatedItem.length > 0) {
                  //console.log('WE have found an item ---> ', updatedItem[0]);
                  let newItem = updatedItem[0];
                  newAutoshipOrder.order.order.months[i]['Fraxel'].push({
                    data: newItem.data,
                    item: fraxelItem.item,
                    quantiy: fraxelItem.quantiy,
                    price: fraxelItem.quantiy * newItem.data[pricingTier],
                  });

                  fraxelTotal += fraxelItem.quantiy * newItem.data[pricingTier];
                }
                return true;
              })
            );
            if (fraxelTotal !== 0) {
              newAutoshipOrder.order.order.months[i].total['Fraxel'] = fraxelTotal;
              monthTotal += fraxelTotal;
              totalOrder += fraxelTotal;
              newAutoshipOrder.order.monthTotals[i].total += fraxelTotal;
            }
          }
        })
      );

      ///////////////////////////////////////////////////////////////////
      //Now we have to go through and add in the Bonus Tips.
      ///////////////////////////////////////////////////////////////////

      //CB Bonus Tips
      if (order.order.order.bonus['Clear + Brilliant'].length > 0) {
        let cbBonusItemCount = 0;
        await Promise.all(
          order.order.order.bonus['Clear + Brilliant'].map((cbBonusItem) => {
            let updatedItem = items.filter((item) => item.data.sku === cbBonusItem.item);
            //console.log('this my bonus new item ---> ', updatedItem);

            if (updatedItem.length > 0) {
              //console.log('WE have found an item ---> ', updatedItem[0]);
              let newItem = updatedItem[0];
              //console.log('this is my new BONUS data item --> ', newItem);

              newAutoshipOrder.order.order.bonus['Clear + Brilliant'].push({
                data: newItem.data,
                item: cbBonusItem.item,
                quantiy: cbBonusItem.quantiy,
              });

              cbBonusItemCount += cbBonusItem.quantiy;
            }
            return true;
          })
        );

        newAutoshipOrder.order.order.bonus.itemCount['Clear + Brilliant'] = cbBonusItemCount;
      }

      //Thermage Bonus Tips

      if (order.order.order.bonus['Thermage'].length > 0) {
        let thermageBonusItemCount = 0;
        await Promise.all(
          order.order.order.bonus['Thermage'].map((thermageBonusItem) => {
            let updatedItem = items.filter((item) => item.data.sku === thermageBonusItem.item);
            if (updatedItem.length > 0) {
              //console.log('WE have found an item ---> ', updatedItem[0]);
              let newItem = updatedItem[0];
              newAutoshipOrder.order.order.bonus['Thermage'].push({
                data: newItem.data,
                item: thermageBonusItem.item,
                quantiy: thermageBonusItem.quantiy,
              });

              thermageBonusItemCount += thermageBonusItemCount.quantiy;
            }
            return true;
          })
        );

        newAutoshipOrder.order.order.bonus.itemCount['Thermage'] = thermageBonusItemCount;
      }

      //Fraxel Bonus Tips

      if (order.order.order.bonus['Fraxel'].length > 0) {
        let fraxelBonusItemCount = 0;
        await Promise.all(
          order.order.order.bonus['Fraxel'].map((fraxelBonusItem) => {
            let updatedItem = items.filter((item) => item.data.sku === fraxelBonusItem.item);
            if (updatedItem.length > 0) {
              //console.log('WE have found an item ---> ', updatedItem[0]);
              let newItem = updatedItem[0];
              newAutoshipOrder.order.order.bonus['Thermage'].push({
                data: newItem.data,
                item: fraxelBonusItem.item,
                quantiy: fraxelBonusItem.quantiy,
              });

              fraxelBonusItemCount += fraxelBonusItemCount.quantiy;
            }
            return true;
          })
        );

        newAutoshipOrder.order.order.bonus.itemCount['Fraxel'] = fraxelBonusItemCount;
      }
    }

    //Lets add in the totals and other values to the system
    newAutoshipOrder.order.totalOrder = totalOrder;

    console.log('this is my order that we will be saving to the database !!!! ', newAutoshipOrder);

    let newOrder = await firestore.collection('autoshipOrders').add({
      ...newAutoshipOrder,
    });

    //Then we will save the order into the database

    //console.log('this is my set data from the database ---> ', newOrder);

    let resp = { id: newOrder.id, data: newAutoshipOrder, clinic: { id: autoShipCompany.id, data: autoShipCompany.data(), naturalTier: { id: autoShipCompany.data().companyNaturalTier, ...naturalTier.data() }, pureTier: { id: autoShipCompany.data().companyPureTier, ...pureTier.data() } } };

    //console.log('this is going to be my response to the reducer --> ', resp);

    //Once we have loaded this into the database lets send it to the reducer and open it up in the ordering screen

    dispatch({ type: 'AUTOSHIP_ORDER_AND_CLINIC_FOUND', resp });
  };
};

export const viewLoadAutoShipCompany = ({ clinicID }) => {
  return (dispatch, getState, { getFirestore }) => {
    const firestore = getFirestore();

    firestore
      .collection('companies')
      .doc(clinicID)
      .get()
      .then((snapShot) => {
        if (!snapShot.isEmpty) {
          let clinic = { id: snapShot.id, data: snapShot.data() };

          firestore
            .collection('tiers')
            .doc(snapShot.data().companyNaturalTier)
            .get()
            .then((natSnapShot) => {
              clinic.naturalTier = natSnapShot.data();
              clinic.naturalTier.id = natSnapShot.id;

              firestore
                .collection('tiers')
                .doc(snapShot.data().companyPureTier)
                .get()
                .then((pureSnapShot) => {
                  clinic.pureTier = pureSnapShot.data();
                  clinic.pureTier.id = pureSnapShot.id;

                  dispatch({ type: 'AUTOSHIP_COMPANY_FOUND', clinic });
                });
            });
        } else {
          dispatch({ type: 'AUTOSHIP_COMPANY_COULD_NOT_BE_FOUND' });
        }
      })
      .catch((err) => {
        dispatch({ type: 'ERROR_FINDING_AUTOSHIP_COMPANY', err });
      });
  };
};

export const autoShipOnChange = (event) => {
  return (dispatch, getState, { getFirestore }) => {
    dispatch({ type: 'AUTOSHIP_ON_CHANGE', event });
  };
};

export const updateAutoShipOrderName = ({ clinic, user, orderID, name, programElevate }) => {
  return (dispatch, getState, { getFirestore }) => {
    const firestore = getFirestore();

    firestore
      .collection('autoshipOrders')
      .doc(orderID)
      .update({
        name: name,
      })
      .then((ref) => {
        //console.log('this is my ref', ref);

        //Create an entrie in the company order listing
        const autoshipField = 'autoShipOrders.' + orderID;
        firestore
          .collection('companies')
          .doc(clinic.id)
          .update({
            [autoshipField]: { created: new Date(), clinic: clinic.data.name, name: name, elvated: programElevate },
          })
          .then(() => {
            //Then add it to the users files
            firestore
              .collection('users')
              .doc(user)
              .update({
                [autoshipField]: { created: new Date(), clinic: clinic.data.name, name: name, elvated: programElevate },
              })
              .then(() => {
                dispatch({ type: 'AUTOSHIP_ORDER_WAS_SAVED' });
              });
          });
      })
      .catch((err) => {
        dispatch({ type: 'ERROR_SAVING_AUTOSHIP_ORDER', err });
      });
  };
};

export const sendAutoShipOrderEmail = ({ orderPDF, userEmail, orderID }) => {
  return async (dispatch, getState, { getFirestore, getFirebase }) => {
    const firestore = getFirestore();
    const firebase = getFirebase();

    let emailSettings = await firestore.collection('settings').doc('email').get();

    firebase
      .storage()
      .ref()
      .child(`/pdfs/${orderPDF.fileName}`)
      .put(orderPDF.file)
      .then((snapShot) => {
        //console.log('this is my order pdf ---- > ', orderPDF);
        console.log('this is my emails that I will be sending out too', emailSettings.data().orders);

        firebase
          .storage()
          .ref(`/pdfs/${orderPDF.fileName}`)
          .getDownloadURL()
          .then((url) => {
            console.log('url', url);
            firestore
              .collection('mail')
              .add({
                //cc: 'ccressman@gmail.com',
                cc: userEmail ? userEmail : ' ',
                //bcc: ['Patrick.Williams@solta.com', 'jsheehy@solta.com', 'orders@solta.com', 'salesoperations@solta.com', 'nilou.ipaktchi@solta.com', 'hnikcevich@solta.com'],
                bcc: emailSettings.data().orders.length > 0 ? emailSettings.data().orders : [''],
                //cc: 'ben@metastudios.co',
                message: {
                  subject: `Your Autoship order has been submitted`,
                  text: `Thanks for participating in your Autoship program. You can find a detail listing of your AutoShip order in the attached pdf -- Solta AutoShip Platform`,
                  html: `<p>Thanks for participating in your Autoship program</p><p>You can find a detail listing of your AutoShip order in the attached pdf</p>  <br/><br/> -- Solta AutoShip Platform`,
                  attachments: [
                    {
                      filename: orderPDF.fileName,
                      path: url,
                      contentType: 'application/pdf',
                      encoding: 'base64',
                    },
                  ],
                },
                orderID: orderID,
              })
              .then((resp) => {
                console.log('this is my resp -----> ', resp);

                dispatch({ type: 'SENT_AUTOSHIP_SUBMITTED_EMAIL_OFF' });
              })
              .catch((err) => {
                console.log('we have an error ', err);

                dispatch({ type: 'ERROR_AUTOSHIP_SUBMITTED_EMAIL_OFF', err });
              });
          });
      });
  };
};

export const deleteAutoShipOrder = ({ clinic, user, order }) => {
  return (dispatch, getState, { getFirestore }) => {
    const firestore = getFirestore();

    firestore
      .collection('autoshipOrders')
      .doc(order)
      .delete()
      .then((ref) => {
        const autoshipField = 'autoShipOrders.' + order;
        firestore
          .collection('companies')
          .doc(clinic)
          .update({
            [autoshipField]: firestore.FieldValue.delete(),
          })
          .then(() => {
            //Then add it to the users files
            firestore
              .collection('users')
              .doc(user)
              .update({
                [autoshipField]: firestore.FieldValue.delete(),
              })
              .then(() => {
                dispatch({ type: 'AUTOSHIP_ORDER_WAS_DELETED' });
              });
          });
      })
      .catch((err) => {
        dispatch({ type: 'ERROR_DELETING_AUTOSHIP_ORDER', err });
      });
  };
};

export const changeShippingID = (index) => {
  return (dispatch, getState, { getFirestore }) => {
    dispatch({ type: 'AUTOSHIP_CHANGE_SHIPPING_ID', index });
  };
};

export const clearAutoShipCompany = () => {
  return (dispatch, getState, { getFirestore }) => {
    dispatch({ type: 'CLEAR_AUTOSHIP_COMPANY' });
  };
};
